(function () {
  var TYPE_SPEED = 58;
  var DELETE_SPEED = 36;
  var HOLD_MS = 2200;
  var BETWEEN_MS = 420;

  function initInput(input) {
    var raw = input.getAttribute('data-atv-search-terms');
    if (!raw) return;

    var terms = raw
      .split('|')
      .map(function (t) {
        return t.trim();
      })
      .filter(Boolean);

    if (!terms.length) return;

    var prefix = input.getAttribute('data-atv-search-prefix') || "Search '";
    var suffix = "'";
    var termIndex = 0;
    var charIndex = 0;
    var deleting = false;
    var paused = false;
    var timerId = null;

    function clearTimer() {
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
      }
    }

    function currentFullText() {
      return prefix + terms[termIndex % terms.length] + suffix;
    }

    function shouldAnimate() {
      return !paused && document.activeElement !== input && !input.value;
    }

    function tick() {
      clearTimer();
      if (!shouldAnimate()) return;

      var full = currentFullText();

      if (!deleting) {
        charIndex = Math.min(charIndex + 1, full.length);
        input.placeholder = full.slice(0, charIndex);

        if (charIndex >= full.length) {
          deleting = true;
          timerId = setTimeout(tick, HOLD_MS);
          return;
        }

        timerId = setTimeout(tick, TYPE_SPEED);
        return;
      }

      if (charIndex <= prefix.length) {
        deleting = false;
        termIndex += 1;
        charIndex = prefix.length;
        input.placeholder = prefix;
        timerId = setTimeout(tick, BETWEEN_MS);
        return;
      }

      charIndex -= 1;
      input.placeholder = full.slice(0, charIndex);

      timerId = setTimeout(tick, DELETE_SPEED);
    }

    function start() {
      if (!shouldAnimate()) return;
      charIndex = prefix.length;
      deleting = false;
      input.placeholder = prefix;
      tick();
    }

    input.addEventListener('focus', function () {
      paused = true;
      clearTimer();
      if (!input.value) {
        input.placeholder = 'Search';
      }
    });

    input.addEventListener('blur', function () {
      paused = false;
      if (!input.value) {
        start();
      }
    });

    input.addEventListener('input', function () {
      if (input.value) {
        clearTimer();
      } else if (!paused && document.activeElement !== input) {
        start();
      }
    });

    start();
  }

  function init() {
    document.querySelectorAll('[data-atv-search-typewriter]').forEach(initInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
